module.exports = __webpack_public_path__ + "static/media/loading12.4759d82b.png";


//////////////////
// WEBPACK FOOTER
// ./src/peaceSharkIndex/index/img/loading/loading12.png
// module id = 197
// module chunks = 0